export default __webpack_public_path__ + "static/media/hero-2.2f1cb188.png";